import loadable from "@loadable/component";
import React from "react";
import StatusIcon from "../../Icons/StatusIcon";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/EndPoint";
const StatusListComponent = loadable(
  () => import("../../components/Status/StatusList")
);

const StatusList = () => {
  const { mutateAsync: patchStatus, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["status"],
    navigateURL: "",
  });
  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value
    };
    const url = `${APIS.STATUS}${id}/`;
    const formData = payload
    try {
      await patchStatus({ url, formData });

    } catch (e) {
      console.log(e)
    }
  }

  const handleIsRTV = async (value: boolean, id: any) => {
    const payload = {
      is_allow_to_create_rtv: value
    };

    const url = `${APIS.USER}${id}/`;
    const formData = payload
    try {
      await patchStatus({ url, formData });

    } catch (e) {
      console.log(e)
    }
  }

  const handleIsFinalState = async (value: any, id: any) => {
    const payload = {
      is_final_state: value
    };
    const url = `${APIS.USER}${id}/`;
    const formData = payload
    try {
      await patchStatus({ url, formData });

    } catch (e) {
      console.log(e)
    }
  }
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">Status</span>
      </div>
      <StatusListComponent
        handleIsActive={handleIsActive}
        handleIsRTV={handleIsRTV}
        handleIsFinalState={handleIsFinalState}
      />
    </>
  );
};

export default StatusList;
